import React from 'react';
import EventsManager from '../features/events/EventsManager';

const EventsManagerPage: React.FC<{ schoolYearId: number }> = ({ schoolYearId }) => {
    return (
        <div className="page">
            <EventsManager schoolYearId={schoolYearId} />
        </div>
    );
};

export default EventsManagerPage;
